import { create } from 'zustand';
import {
  TOnboardingAccount,
  TOnboardingPayment,
  TradingPlatForms,
} from '@src/types';

interface CreatePaAccountState {
  platform: string;
  payment: TOnboardingPayment | null;
  account: TOnboardingAccount | null;
  setPlatform: (platform: string) => void;
  setPayment: (payment: TOnboardingPayment) => void;
  setAccount: (account: TOnboardingAccount | null) => void;
  reset: () => void;
}

export const useCreatePaAccountCheckout = create<CreatePaAccountState>()((
  set
) => {
  return {
    platform: TradingPlatForms.RITHMIC_DATA_FEED,
    account: null,
    payment: null,
    setPlatform: (platform) => set((state) => ({ ...state, platform })),
    setAccount: (account) => set((state) => ({ ...state, account })),
    setPayment: (payment) => set((state) => ({ ...state, payment })),
    reset: () =>
      set((state) => {
        return {
          ...state,
          payment: null,
          account: null,
        };
      }),
  };
});
